import React, { FunctionComponent } from 'react';
import { withRouter } from 'react-router-dom';

import ProtectedRoute from 'components/ProtectedRoute';
import { WithRouterProps } from 'helpers/types';

import ListUsers from './scenes/ListUsers';

type Props = WithRouterProps;

const UsersSummary: FunctionComponent<Props> = ({ match }) => (
  <ProtectedRoute path={`${match.url}/list`} component={ListUsers} />
);

export default withRouter(UsersSummary);
